module.exports = require("@projectstorm/react-diagrams-defaults");